import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { AppStore } from '@core/store/app-store'

import { UserProfileBadge } from '../user-profile-badge/user-profile-badge'
import { RouterLink } from '@angular/router'
import { IconApp } from '@shared/components'
import { AuthService } from '@core/auth'

@Component({
  selector: 'mobile-header',
  imports: [UserProfileBadge, RouterLink, IconApp],
  templateUrl: './mobile-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'relative sticky top-0 z-50 flex w-full gap-0.5 px-4 py-3 pl-24 bg-primary-700 items-center shadow-card overflow-visible'
  }
})
export class MobileHeader {
  #appStore = inject(AppStore)
  #authService = inject(AuthService)

  user = computed(() => this.#appStore.currentUser())

  logout() {
    this.#authService.logout()
  }
}
